/**
 * Information annexe dans la thematique
 */
export class ThematiqueData {
    /**
     * Constructeur de thématiqueData
     * @param thematiqueData à construire
     */
    constructor(thematiqueData) {
        if (thematiqueData) {
            const { libelleThematique, sujetAmount } = thematiqueData;
            this.libelleThematique = libelleThematique;
            this.sujetAmount = sujetAmount;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            libelleThematique: this.libelleThematique,
            sujetAmount: this.sujetAmount,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGhlbWF0aXF1ZURhdGEuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJUaGVtYXRpcXVlRGF0YS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxjQUFjO0lBVzFCOzs7T0FHRztJQUNILFlBQW1CLGNBQXdDO1FBQzFELElBQUksY0FBYyxFQUFFO1lBQ25CLE1BQU0sRUFBRSxpQkFBaUIsRUFBRSxXQUFXLEVBQUUsR0FBRyxjQUFjLENBQUM7WUFFMUQsSUFBSSxDQUFDLGlCQUFpQixHQUFHLGlCQUFpQixDQUFDO1lBQzNDLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO1NBQy9CO0lBQ0YsQ0FBQztJQUVEOzs7T0FHRztJQUNJLEtBQUs7UUFDWCxPQUFPO1lBQ04saUJBQWlCLEVBQUUsSUFBSSxDQUFDLGlCQUFpQjtZQUN6QyxXQUFXLEVBQUUsSUFBSSxDQUFDLFdBQVc7U0FDN0IsQ0FBQztJQUNILENBQUM7Q0FDRCJ9